export class BwjEventArgs<T> {
  constructor(eventArgs: T) {
    this.args = eventArgs;
  }

  public accessible() { return this.handled === false; }
  public inaccessible() { return this.handled; }
  public getArgs() {
    if(this.handled) {
      throw new ReferenceError('Event arg has been read, and is no longer available');
    }

    this.handled = true;
    return this.args;
  }

  private args: T;
  private handled: boolean = false;
}